import React, {
  useEffect,
  useRef,
  useReducer,
  createContext,
  useContext
} from 'react';
import Toast from './Toast';
import { v4 } from 'uuid';

const ToastDispatchContext = createContext(undefined);

function toastReducer(state, action) {
  switch (action.actionType) {
    case 'add':
      return {
        ...state,
        toasts: [
          ...state.toasts,
          {
            message: action?.message ?? { text: '', variant: 'info' },
            timeShown: action.timeShown,
            showProgress: action.showProgress,
            onClose: action.onClose,
            uuid: v4()
          }
        ]
      };
    case 'remove':
      const el = state.toasts.findIndex(item => item.uuid === action.uuid);
      let toasts = [...state.toasts];
      toasts.splice(el, 1);
      return {
        ...state,
        toasts
      };
    default:
      return {
        ...state,
        toasts: [
          ...state.toasts,
          {
            message: action?.message ?? { text: '', variant: 'info' },
            timeShown: action.timeShown,
            showProgress: action.showProgress,
            onClose: action.onClose,
            uuid: v4()
          }
        ]
      };
  }
}

function ToastProvider({ children }) {
  const [state, dispatch] = useReducer(toastReducer, {
    toasts: []
  });
  const ref = useRef({});

  useEffect(() => {
    // Check that all toasts have timers
    state.toasts.forEach(toast => {
      if (!ref.current[toast.uuid]) {
        const t = setTimeout(() => {
          dispatch({
            actionType: 'remove',
            uuid: toast.uuid
          });
          ref.current[toast.uuid] = undefined;
        }, toast.timeShown ?? 12000);
        ref.current[toast.uuid] = t;
      }
    });
  }, [state.toasts]);

  return (
    <ToastDispatchContext.Provider value={dispatch}>
      <div
        style={{
          position: 'fixed',
          zIndex: 10000,
          paddingBottom: 50,
          bottom: 0,
          right: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          overflow: 'hidden',
          width: 560,
          height: 'auto',
          pointerEvents: 'none'
        }}
      >
        {state.toasts.map((toast, index) => (
          <Toast
            message={toast.message}
            onClose={() => dispatch({ actionType: 'remove', uuid: toast.uuid })}
            showProgress={toast.showProgress}
            timeShown={toast.timeShown}
            key={toast.uuid || index}
          />
        ))}
      </div>
      {children}
    </ToastDispatchContext.Provider>
  );
}

function useToast() {
  const context = useContext(ToastDispatchContext);
  if (context === undefined) {
    throw new Error('ToastDispatch must be used with ToastProvider');
  }
  return context;
}

export { ToastProvider, useToast };
